import moment from "moment";
import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";

const LogsTrend = ({ logDistribution }) => {
	const timelineLabels = useMemo(() => {
		let startX = logDistribution.startX;
		let endX = logDistribution.endX;
		let groupByPeriod = logDistribution.groupByPeriod;
		let labels = [];
		while (startX < endX) {
			labels.push(moment(startX).format("HH:mm"));
			startX += groupByPeriod;
		}
		return labels;
	}, [logDistribution]);

	const lineChartData = (chartData) => {
		return {
			labels: timelineLabels,
			datasets: [
				{
					data: chartData.values,
					borderWidth: 1,
					lineTension: 0,
					elements: { point: { radius: 1 } },
				},
			],
		};
	};

	return (
		<Bar
			data={lineChartData(logDistribution)}
			options={{
				backgroundColor: "orange",
				borderColor: "black",
				color: "green",
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: false,
					},
				},
			}}
		/>
	);
};

export default LogsTrend;
